<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="true"
    />
    <ul class="detalhamento-cirurgia">
      <li>
        {{ $t('areas.cirurgias-informacoes-paciente.lista-espera-01') }}
        <span class="status-lista-espera">{{
          $t('areas.cirurgias-informacoes-paciente.lista-espera-02')
        }}</span>
      </li>
      <li>
        {{
          $t('areas.cirurgias-informacoes-paciente.contato-agendamento_exames')
        }}
      </li>
    </ul>
  </div>
</template>

<script>
import CirurgiaService from '@/services/cirurgia-service'
import { NotAuthenticatedError } from '../../../../../models/not-authenticated-error'

export default {
  name: 'StatusListaDeEsperaContent',
  props: {
    cirurgia: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      tempoCirurgia: null,
      isLoading: false
    }
  },
  async mounted() {
    this.isLoading = true
    await CirurgiaService.getTempoEspera(this.cirurgia)
      .then((res) => {
        if (!res.ok && res.status !== 200) {
          if (res.status === 401) throw new NotAuthenticatedError()
          throw new Error(`HTTP error, status ${res.status}`)
        }
        return res.json()
      })
      .then((data) => {
        this.tempoCirurgia = data.TempoEspera
        this.isLoading = false
      })
      .catch((err) => {
        this.isLoading = false
        throw err
      })
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
.status-lista-espera {
  color: var(--blue);
  font-weight: bold;
}

ul.detalhamento-cirurgia {
  list-style: circle;
  text-align: left;
  padding-left: 25px;
  li {
    margin-bottom: 5px;
  }
  a {
    color: var(--light-blue);
  }
}
</style>
